import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class PrefillMooIgnoreExperienceCheckFeature implements IFlagFeature {
  name = Features.PREFILL_MO_IGNORE_EXPERIENCE_CHECK;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
